import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { CurrencyPairQuote, ExchangeRatesResponse } from './entities';
import { Session } from '@benzinga/session';
import { ForexEnvironment } from './environment';

export class ForexRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ForexEnvironment).url, session, { 'x-device-key': true });
  }

  getCurrencyPairQuote = (currencyPair: string): SafePromise<CurrencyPairQuote> => {
    const url = this.URL(`api/forex`, {
      currencyPair,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'omit' });
  };

  public getExchangeRates = async (currency: string): SafePromise<ExchangeRatesResponse> => {
    const url = this.URL(`api/forex`, {
      currency,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'omit' });
  };
}
